import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CheckResponse } from "../../../model/auth-response";
import {
  setLastCheckEmail,
  clearLastCheckedEmail,
} from "../../../shared/storage";

const initialState: {
  data: CheckResponse | null;
  pending: boolean;
  error: boolean;
} = {
  data: null,
  pending: false,
  error: false,
};

export const checkStore = createSlice({
  name: "check",
  initialState,
  reducers: {
    check(state) {
      clearLastCheckedEmail();

      return {
        ...state,
        pending: true,
      };
    },
    checkSuccess(state, action: PayloadAction<CheckResponse>) {
      setLastCheckEmail(action.payload.email);

      return {
        ...state,
        data: action.payload,
        pending: false,
      };
    },
    checkFail(state) {
      return { ...state, pending: false, error: true };
    },
  },
});

export const { check, checkFail, checkSuccess } = checkStore.actions;
